module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/idb-logo-8fbe3c51816a30c1dc7ebf877376f592.svg&quot;;"